import { TopBar } from '@equinor/eds-core-react';
import { useNavigate } from 'react-router-dom';
import * as Styled from './AppBar.styled';
import { Icons } from './Icons/Icons';
import pepmLogo from '../../assets/pepm logo dark.svg';
import pepmWordmark from '../../assets/pepm letters long v2.svg';

const AppBar = () => {
  const navigate = useNavigate();

  return (
    <Styled.TopBar>
      <Styled.Header
        onClick={() => {
          navigate('/home');
        }}
      >
        <Styled.Logo src={pepmLogo} alt="" />
        <Styled.Wordmark
          src={pepmWordmark}
          alt="Parameter Estimation from Process Models"
        />
      </Styled.Header>
      <TopBar.Actions>
        <Icons />
      </TopBar.Actions>
    </Styled.TopBar>
  );
};

export default AppBar;
